import type { Location, Hazard } from '@/types';

export const LOCATIONS: Location[] = [
  {
    id: 'portland',
    name: 'Portland, Maine',
    coords: { x: 25, y: 25 },
    description: 'A charming port city with a working waterfront, historic Old Port district, and beautiful Casco Bay islands.',
    hint: 'charming port islands',
  },
  {
    id: 'boston',
    name: 'Boston Harbor',
    coords: { x: 20, y: 45 },
    description: 'A historic harbor, home to old warships and bustling with modern vessels. The city skyline provides a stunning backdrop.',
    hint: 'historic harbor city',
  },
  {
    id: 'cape-cod',
    name: 'Cape Cod Bay',
    coords: { x: 40, y: 55 },
    description: 'Known for its sandy dunes, lighthouses, and quaint seaside towns. A perfect spot for catching sunrises.',
    hint: 'sandy dunes lighthouse',
  },
  {
    id: 'newport',
    name: 'Newport, Rhode Island',
    coords: { x: 18, y: 75 },
    description: 'Famous for its Gilded Age mansions, sailing history, and the scenic Cliff Walk. A hub of maritime elegance.',
    hint: 'sailing mansions',
  },
  {
    id: 'nantucket',
    name: 'Nantucket Island',
    coords: { x: 50, y: 90 },
    description: 'A remote, cobblestoned island known for its whaling history, pristine beaches, and cedar-shingled buildings.',
    hint: 'whaling island beaches',
  },
];

export const HAZARDS: Hazard[] = [
  {
    id: 'shark-1',
    type: 'shark',
    coords: { x: 70, y: 40 },
    name: 'Shark Sighting',
  },
  {
    id: 'buoy-1',
    type: 'buoy',
    coords: { x: 30, y: 65 },
    name: 'Navigational Buoy',
  },
  {
    id: 'ship-1',
    type: 'ship',
    coords: { x: 80, y: 80 },
    name: 'Fellow Merchant Ship',
  },
  {
    id: 'shark-2',
    type: 'shark',
    coords: { x: 15, y: 85 },
    name: 'Great White',
  },
  {
      id: 'buoy-2',
      type: 'buoy',
      coords: { x: 60, y: 15 },
      name: 'Weather Buoy'
  }
];

export const MAP_BOUNDS = {
    minX: 0,
    maxX: 100,
    minY: 0,
    maxY: 100
};

export const SHIP_SPEED = 5;
export const LOCATION_PROXIMITY_THRESHOLD = 7;
export const HAZARD_PROXIMITY_THRESHOLD = 4;
export const TURN_ANGLE = 15;
